/**
 * Function to filter states based on a search term - e.g 'qld', 'queen...'
 *
 * @param term
 * @param item
 */
export const stateSearchFn = (term: string, item: any) => {
	if (!term) return true;

	const searchTerm = term.toLowerCase();
	const name = item.name?.toLowerCase() || '';
	const abbreviation = item.abbreviation?.toLowerCase() || '';

	return name.includes(searchTerm) || abbreviation.includes(searchTerm);
};